import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("CHAT_STATUS"),
};
